export default __webpack_public_path__ + "static/media/solanaLogo.4396455e.svg";